(function(){

const COOKIE_NAME="tic_cookie_consent";
const DAYS=60;

function setCookie(name,value,days){

const date=new Date();

date.setTime(date.getTime()+(days*86400000));

document.cookie=name+"="+value+
";expires="+date.toUTCString()+
";path=/;SameSite=Lax";

}

function getCookie(name){

const value="; "+document.cookie;

const parts=value.split("; "+name+"=");

if(parts.length===2)

return parts.pop().split(";").shift();

return null;

}

function setConsent(granted){

if(window.Shopify && Shopify.customerPrivacy){

Shopify.customerPrivacy.setTrackingConsent({

analytics:granted,

marketing:granted,

preferences:true,

sale_of_data:false

},function(){});

}

}

document.addEventListener("DOMContentLoaded",function(){

const banner=document.getElementById("tic-cookie-banner");

if(!banner)return;

if(!getCookie(COOKIE_NAME)){

banner.hidden=false;

}

document.getElementById("tic-accept").onclick=function(){

setCookie(COOKIE_NAME,"accepted",DAYS);

setConsent(true);

banner.hidden=true;

};

document.getElementById("tic-reject").onclick=function(){

setCookie(COOKIE_NAME,"rejected",DAYS);

setConsent(false);

banner.hidden=true;

};

});

})();